import { Controller, useFormContext } from 'react-hook-form'
import { Accept, useDropzone } from 'react-dropzone'
import { ChangeEventHandler, FC } from 'react'

import styles from './DropzoneField.module.css'

export const DropzoneField: FC<{ name: string; multiple?: boolean; accept?: Accept }> = ({
  name,
  multiple,
  accept,
  ...rest
}) => {
  const { control, watch } = useFormContext()

  const selectedFiles = watch('files')

  return (
    <Controller
      render={({ field: { onChange } }) => (
        <Dropzone
          multiple={multiple}
          onChange={(e) => onChange(e.target.files)}
          selectedFiles={selectedFiles}
          accept={accept}
          {...rest}
        />
      )}
      name={name}
      control={control}
      defaultValue=""
    />
  )
}

const Dropzone: FC<{
  multiple?: boolean
  onChange?: ChangeEventHandler<HTMLInputElement>
  selectedFiles?: FileList
  accept?: Accept
}> = ({ multiple, onChange, selectedFiles, accept, ...rest }) => {
  const { getRootProps, getInputProps } = useDropzone({
    multiple,
    accept,
    ...rest,
  })

  let uploadedFileNames = null
  if (selectedFiles?.length) {
    uploadedFileNames = Array.from(selectedFiles)
      .map((file: File) => file.name)
      .join(', ')
  }

  return (
    <div {...getRootProps({ className: styles.dropzoneFieldWrapper })}>
      <input {...getInputProps({ onChange })} />
      {!uploadedFileNames ? (
        <p>Click here to upload or drag file</p>
      ) : (
        <p className={styles.selectedFileNames}>{uploadedFileNames}</p>
      )}
    </div>
  )
}
